<template>
    <b-container fluid class="mt-3">
        <b-row>
            <b-col md="6">
                <b-row class="mb-3">
                    <b-col cols="auto" class="mr-auto"><h4>Client Instance List</h4></b-col>
                    <b-col cols="auto">
                        <b-link :to="{ name: 'NewClient'}" class="h4 text-primary">
                            <b-icon icon="plus-circle"></b-icon>
                        </b-link>
                    </b-col>
                </b-row>
                <b-row class="mb-3">
                    <b-col md="12">
                        <b-input-group>
                            <b-form-input placeholder="Search by name" v-model="name" @input="searchName"></b-form-input>
                            <b-input-group-append>
                                <b-button squared variant="outline-secondary" @click="searchName">Search</b-button>
                                <b-button squared variant="outline-primary" @click="getClients">All</b-button>
                            </b-input-group-append>
                        </b-input-group>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col md="12">
                        <b-pagination v-model="currentPage" :total-rows="rows" :per-page="perPage" align="fill"
                                      aria-controls="my-clients"></b-pagination>

                        <b-list-group id="my-clients" v-if="clients != null">
                            <b-list-group-item class="text-center" v-if="clients.length === 0">
                                No client instance found
                            </b-list-group-item>
                            <b-list-group-item button v-for="(client, index) in clientsForList"
                                               :key="index"
                                               :active="index === currentIndex"
                                               @click="setActiveClient(client, index)">
                                <b-avatar :text="client.shortName" :variant="client.color.startsWith('#') ? '' : client.color"
                                          :style="client.color.startsWith('#') ? `color: #fff; background: ${client.color}` : ''"
                                          class="mr-3"></b-avatar>
                                <span class="mr-auto">{{ client.name }}</span>
                            </b-list-group-item>
                        </b-list-group>
                        <div v-if="clients == null" class="text-center">
                            <b-spinner label="Spinning"></b-spinner>
                        </div>
                    </b-col>
                </b-row>
            </b-col>
            <b-col md="6">
                <div v-if="currentClient">
                    <b-row class="mb-2">
                        <b-col md="12">
                            <h4>Client Instance</h4>
                        </b-col>
                    </b-row>

                    <b-row>
                        <b-col md="12" class="mb-2">
                            <div>
                                <label><strong>Name:</strong></label> {{ currentClient.name }}
                            </div>
                            <div>
                                <label><strong>Tenant:</strong></label> {{ currentClient.settings.tenant }}
                            </div>
                            <b-row class="mb-2">
                                <b-col md="6">
                                    <label><strong>Partner Url:</strong></label>
                                    {{ currentClient.settings != null ? currentClient.settings.partnerUrl : ""}}
                                </b-col>

                                <b-col md="6" class="text-right">
                                    <b-button @click="testConnection" variant="outline-primary">
                                        <b-icon icon="wifi"></b-icon>
                                        Test connection
                                    </b-button>
                                </b-col>
                            </b-row>

                            <b-overlay :show="showConnectionStatus != null && !showConnectionStatus && !connectionStatus" spinner-variant="primary" spinner-type="grow" spinner-small
                                       style="min-height: 100px">
                                <b-list-group v-if="showConnectionStatus && connectionStatus">
                                    <monitoring-line v-for="(co, key, index) in connectionStatus" :key="index"
                                                     :id-key="'line-'+index" :error="co.message" :is-alive="co.alive"
                                                     :label="'Connection to ' + key"/>
                                </b-list-group>
                            </b-overlay>
                        </b-col>

                        <b-col md="12" class="text-center">
                            <b-button squared variant="primary"
                                      :to="{ name: 'Client', params: { id: currentClient.id } }">
                                <b-icon icon="info-circle"></b-icon>
                                Detail
                            </b-button>
                        </b-col>
                    </b-row>
                </div>
            </b-col>
        </b-row>
    </b-container>

</template>

<script>
    import ClientDataService from "../../services/ClientDataService";
    import MonitoringLine from "@/components/configuration/MonitoringLine";

    export default {
        name: "ClientList",
        created() {
            document.title = "Configuration : Clients";
        },
        components: {
            MonitoringLine,
        },
        data() {
            return {
                clients: null,
                perPage: 10,
                currentPage: 1,
                currentClient: null,
                currentIndex: -1,
                name: "",
                connectionStatus: null,
                showConnectionStatus: false
            }
        },
        computed: {
            rows() {
                return this.clients ? this.clients.length : 0;
            },
            clientsForList() {
                if (this.clients) {
                    return this.clients.slice(
                        (this.currentPage - 1) * this.perPage,
                        this.currentPage * this.perPage,
                    );
                } else {
                    return null;
                }
            }
        },
        mounted() {
            this.getClients();
        },
        methods: {
            getClients() {
                ClientDataService.getAll()
                    .then(response => (this.clients = response.data))
                    .catch(error => console.log(error))
            },
            setActiveClient(client, index) {
                this.currentClient = client;
                this.currentIndex = index;
                this.showConnectionStatus = null;
            },
            searchName() {
                ClientDataService.findByName(this.name)
                    .then(response => (this.clients = response.data))
                    .catch(error => console.log(error))
            },
            testConnection() {
                this.showConnectionStatus = false;
                ClientDataService.testConnection(this.currentClient.id)
                    .then(response => {
                        this.connectionStatus = response.data;
                        this.showConnectionStatus = true;
                    })
                    .catch(error => console.log(error));
            }
        }
    }
</script>

<style scoped>

</style>